import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "up",
  "use": "up-usage",
  "viewBox": "0 0 12 8",
  "content": "<symbol viewBox=\"0 0 12 8\" id=\"up\"><path fill-rule=\"evenodd\" d=\"M6 2.4l4.8 4.8L12 6 6 0 0 6l1.2 1.2L6 2.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chevron/up.svg
// module id = ./src/assets/icons/chevron/up.svg
// module chunks = 4